import { type FC, type ReactNode, useContext } from 'react';
import { StringSmall } from '@components/Typography/Typography';
import {
  Button,
  GreyBlurSmButton,
  MainSmButton,
} from '@components/ui/Button/Button';
import cn from 'classnames';

import { TabsContext } from './context';

import css from './styles.module.scss';

interface TabsNavigationProps {
  list: { id: string; label: string; disabled?: boolean }[];
  onTabChange?: (id: string) => void;
  variant?: 'grey' | 'default';
  indexWithIndicator?: string;
  ticker?: () => ReactNode;
  className?: string;
}

const TabsNavigation: FC<TabsNavigationProps> = ({
  list,
  onTabChange,
  variant = 'default',
  indexWithIndicator,
  ticker,
  className,
}) => {
  const { activeTabId, setActiveTabId } = useContext(TabsContext);

  return (
    <div className={cn(css.tabs, className)}>
      {list.map(({ id, label, disabled }) => (
        <div className="flex-1 relative" key={id}>
          {activeTabId === id ? (
            variant === 'default' ? (
              <MainSmButton text={label} />
            ) : (
              <GreyBlurSmButton text={label} />
            )
          ) : (
            <Button
              disabled={!!disabled}
              className="h-full flex items-center justify-center"
              onClick={() => {
                if (onTabChange) {
                  onTabChange(id);
                }

                setActiveTabId(id);
              }}
              variant="transparent"
            >
              <StringSmall weight="bold" className="text-white/40">
                {label}
              </StringSmall>
            </Button>
          )}
          {indexWithIndicator && indexWithIndicator === '2' && (
            <div className="top-3 right-3 activeGreenPoint"></div>
          )}
        </div>
      ))}
      {ticker ? ticker() : null}
    </div>
  );
};

export { TabsNavigation };
